import { UserNotice } from '../types'

export const noticeFormDefaultValues = (data: UserNotice | undefined) => {
  return {
    isEmailOn: data?.isEmailOn || false,
    isSmsOn: data?.isSmsOn || false,
    isWhatsAppOn: data?.isWhatsAppOn || false,
    isTelegramOn: data?.isTelegramOn || false,
    agreeSubscribeAdvertising: data?.agreeSubscribeAdvertising || false,
  }
}
